// @charset "utf-8";
import { logRequest, transformResponse, loadCefEnd } from './utils'

// API接口描述
const descriptionMap = {
    getLoginInfo: '获取登录信息',
    queryBrokerList: '查询券商列表',
    querySiteInfo: '查询站点信息',
    checkImportFile: '检查导入文件',
    importAccounts: '导入账户CSV文件',
    getExportPath: '获取导出路径',
    exportAccounts: '导出账户',
    queryIsLogin: '查询是否登录',
    getProductInfo: '获取MAC和IP',
    sendHttpRequest: '发送HTTP请求'
}

const apiMap = {
    getLoginInfo: {
        name: 'cef.get_logininfo',
        hasParams: false
    },
    queryBrokerList: {
        name: 'facade.QueryBrokerInfo',
        defaultParams: { downloadbrokerinfoflag: 5 }
    },
    querySiteInfo: {
        name: 'facade.QueryBrokerInfo',
        defaultParams: { downloadbrokerinfoflag: 4 }
    },
    checkImportFile: {
        name: 'page.OutPutPath',
        hasParams: false
    },
    importAccounts: 'page.OutPutAccountInfo',
    getExportPath: {
        name: 'page.InputPath',
        hasParams: false
    },
    exportAccounts: 'page.InputAccountInfo',
    queryIsLogin: 'facade.QueryIsLogin',
    getProductInfo: 'page.getProductInfo'
}

function generateFuncs () {
    const exportFuncs = {}
    Object.keys(apiMap).forEach(funcName => {
        const api = typeof apiMap[funcName] === 'string' ? { name: apiMap[funcName] } : apiMap[funcName]
        const { name: apiName, defaultParams = {}, hasParams = true } = api
        const func = async function () {
            await loadCefEnd()
            apiName.split('.').reduce((a, b) => a[b], window)(...arguments)
        }
        const description = descriptionMap[funcName]
        exportFuncs[funcName] = (params = {}) => {
            const newParams = Object.assign({}, defaultParams, params)
            const id = Date.now()
            logRequest({ id, apiName, params: newParams, description })
            return new Promise((resolve, reject) => {
                const callback = res => {
                    const { status, result, error } = transformResponse({
                        id,
                        apiName,
                        params: newParams,
                        description,
                        res
                    })
                    if (status) {
                        resolve(...result)
                    } else {
                        reject(error)
                    }
                }
                if (hasParams) {
                    func(newParams, callback)
                } else {
                    func(callback)
                }
            })
        }
    })
    return exportFuncs
}

export default generateFuncs()



// WEBPACK FOOTER //
// ./src/api/client.js